var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShown)?_c('div',{staticClass:"overflow-indicator__gradient"},[_c('ArrowButton',{class:[_vm.direction],attrs:{"onClick":_vm.onClick}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }